export { NumberInput } from '../src/NumberInput';
